import { takeUntil, map } from 'rxjs/operators';
import { Tenant } from './../../../../domain/tenant';
import { selectCxbSelectedTenant } from './../../../../app.selectors';
import { RootAppState, AppState } from './../../../../app.reducer';
import { ChangeDetectionStrategy, Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouterReducerState, RouterState } from '@ngrx/router-store';
import { Observable, Subject } from 'rxjs';

export enum TenantLogoSection {
  Main = 'main',
  Profile = 'profile',
}

@Component({
  selector: 'osn-cxb-tenant-logo',
  templateUrl: './tenant-logo.component.html',
  styleUrls: ['./tenant-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantLogoComponent implements OnInit, OnDestroy {
  @Input() public section: TenantLogoSection = TenantLogoSection.Main;

  private readonly destroyed$ = new Subject<void>();

  public selectedTenant$: Observable<Tenant> = this.store.select(selectCxbSelectedTenant);

  public readonly isTenantIndependentRoute$ = this.rootStore
    .select((state: { router: RouterReducerState; app: AppState }) => state.router?.state?.url)
    .pipe(
      takeUntil(this.destroyed$),
      map((url) => url?.startsWith('/root'))
    );

  public TenantLogoSection = TenantLogoSection;

  constructor(
    private readonly store: Store<RootAppState & RouterState>,
    private readonly rootStore: Store<{ router: RouterReducerState; app: AppState }>
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
